import { useEffect } from 'react';

// Mobile browsers resize window.innerHeight as the address bar shows/hides,
// so a plain `vh` unit drifts from the real viewport. Expose the actual
// value as a CSS custom property so any page/component can use
// `calc(var(--vh, 1vh) * 100)` instead of `100vh`. Set once at the app root
// so it's available before any individual page mounts.
export default function useRealViewportHeight() {
  useEffect(() => {
    const setVh = () => {
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
    };
    setVh();
    window.addEventListener('resize', setVh);
    return () => window.removeEventListener('resize', setVh);
  }, []);
}
